module.exports = __webpack_public_path__ + "img/singapore.9f1f2806.png";